import { Skeleton } from "@/components/Skeleton";

export default function Loading() {
  return (
    <div className="w-full max-w-5xl">
      <div className="mt-5 w-full flex flex-col gap-3">
        <Skeleton className="w-full h-5" />
        <Skeleton className="w-full h-5" />
        <Skeleton className="w-full h-5" />
        <Skeleton className="w-full h-5" />
      </div>
    </div>
  );
}
